import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { FishTank } from './components/FishTank';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<FishTank />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
